import { useEffect, useRef } from 'react';
import { Box, Button, Container, Grid, Typography } from '@mui/joy';
import Post from '../../../components/module/Post/Post';
import { FadeIn } from './FadeIn';

const hoursAgo = (h) => new Date(Date.now() - h * 60 * 60 * 1000).toISOString();

const DEMO_POSTS = [
    {
        id: 'post-1',
        idUser: 101,
        idPost: 1,
        status: 1,
        myPost: false,
        created_at: hoursAgo(7),
        user: {
            id: 101,
            firstName: 'Марина',
            lastName: 'Котова',
            username: 'marina',
            verified: true,
            avatar: `${process.env.REACT_APP_URL}/img/welcome/12.jpg`,
        },
        content: '<p>Доплыла до выходных, утром выбралась на набережную. Вода спокойная, чайки галдят, и впервые за неделю никуда не спешу. 🧘‍♀️</p>',
        countLikes: 128,
        like: true,
        countComments: 24,
        countViews: 1503,
    },
    {
        id: 'post-2',
        idUser: 102,
        idPost: 2,
        status: 1,
        myPost: false,
        created_at: hoursAgo(9),
        user: {
            id: 102,
            firstName: 'Артём',
            lastName: 'Лебедев',
            username: 'artem',
            verified: false,
            avatar: `${process.env.REACT_APP_URL}/img/welcome/34.jpg`,
        },
        content: '<p>Выкатили новый набор стикеров «Глубина». Рисовали его всей командой почти месяц. Загляните в чаты, теперь рыбки у вас на экране. 🐙</p>',
        countLikes: 342,
        like: false,
        countComments: 57,
        countViews: 4821,
    },
];

function DemoFeed() {
    const ref = useRef(null);

    useEffect(() => {
        const root = ref.current;
        if (!root) return;

        root.inert = true;

        root.querySelectorAll('a, button, input, textarea, select, [tabindex]')
            .forEach((el) => { el.setAttribute('tabindex', '-1'); });
    });

    return (
        <Box
            ref={ref}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                cursor: 'default',
                pointerEvents: 'none !important',
                '& *': { cursor: 'default !important' },
            }}
        >
            {DEMO_POSTS.map((post) => (
                <Post key={post.id} post={post} />
            ))}
        </Box>
    );
}

export function MicroblogSection() {
    return (
        <Container maxWidth="lg">
            <Box sx={{ my: { md: 12, xs: 6 } }}>
                <Grid container spacing={{ xs: 3, md: 6 }} alignItems="center">
                    <Grid xs={12} md={6}>
                        <FadeIn>
                            <Typography
                                level="h2"
                                sx={{ fontWeight: 700, fontSize: { xs: '1.7rem', md: '2.5rem' }, mb: 2 }}
                            >
                                Лента, в которой<br />приятно находиться
                            </Typography>
                            <Typography level="body-lg" sx={{ color: 'text.secondary', mb: 3 }}>
                                Записи друзей и любимых авторов, без алгоритмов и рекламы.
                                Публикуйте мысли и фотографии, собирайте лайки и обсуждайте
                                в комментариях.
                            </Typography>
                            <Button
                                size="lg"
                                variant="solid"
                                component="a"
                                href="https://aquarium.org.ru/auth"
                                sx={{ borderRadius: '999px', px: 4, fontWeight: 700, textDecoration: 'none !important' }}
                            >
                                Создать первую запись
                            </Button>
                        </FadeIn>
                    </Grid>
                    <Grid xs={12} md={6}>
                        <FadeIn delay={0.15} y={40}>
                            <DemoFeed />
                        </FadeIn>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
}
